import { render, staticRenderFns } from "./DegreeDistributionChart.vue?vue&type=template&id=6ae1c170&scoped=true"
import script from "./DegreeDistributionChart.vue?vue&type=script&lang=js"
export * from "./DegreeDistributionChart.vue?vue&type=script&lang=js"
import style0 from "./DegreeDistributionChart.vue?vue&type=style&index=0&id=6ae1c170&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae1c170",
  null
  
)

export default component.exports